import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TrocarLocalidadeComponent } from './trocar-localidade.component.page';
import { LocalidadeComponentModule } from '../localidade/localidade.component.module';
import { LocalidadeUfMunicipioComponentModule } from '../localidade-uf-municipio/localidade-uf-municipio.component.module';

@NgModule({
  entryComponents: [TrocarLocalidadeComponent],
    imports: [CommonModule, FormsModule, IonicModule, LocalidadeComponentModule, LocalidadeUfMunicipioComponentModule],
  declarations: [TrocarLocalidadeComponent],
  exports: [
    TrocarLocalidadeComponent
  ]
})
export class TrocarLocalidadeComponentModule { }
